import Box from "@mui/material/Box";

import DeleteReserveButton from "./DeleteReserveButton";

type ReserveActionsProps = {
  reserveId: string;
  refetchReserve: () => void;
};

export default function ReserveActions({
  reserveId,
  refetchReserve,
}: ReserveActionsProps) {
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}>
      <DeleteReserveButton reserveId={reserveId} refetchReserve={refetchReserve} />
    </Box>
  );
}
